import en from './locales/en.json';
import de from './locales/de.json';

export const ibanSwiperLocales = {
  en: { ibanSwiper: en },
  de: { ibanSwiper: de },
};

export { default as IbanSwiper } from './IbanSwiper.vue';
export { default as IbanSwiperSlide } from './components/IbanSwiperSlide.vue';
